import { useCountUp } from "@/lib/aht/hooks";
import { fmtDecimal } from "@/lib/aht/format";

// Counts up once. The final value reserves the width so nothing shifts.
export function CountUp({ value, start, decimals = 0, plain = false, prefix = "", suffix = "", duration = 0.9, delay = 0, align = "left", className = "" }) {
  const v = useCountUp(value, start, { duration, delay });
  const fmt = (n) => (plain ? n.toFixed(decimals) : fmtDecimal(n, decimals));
  const finalText = `${prefix}${fmt(value)}${suffix}`;
  return (
    <span className={`relative inline-block tnum ${className}`}>
      <span className="sr-only">{finalText}</span>
      <span aria-hidden="true" className="invisible">{finalText}</span>
      <span
        aria-hidden="true"
        className="absolute inset-0 whitespace-nowrap"
        style={{ textAlign: align }}
      >
        {prefix}
        {fmt(v)}
        {suffix}
      </span>
    </span>
  );
}
